import React from 'react';
import { translate } from 'react-i18next';

import { apiUrl } from '../env';

function BackElement({ t, type = 'link' }) {
  function backLink() {
    if (!document.referrer) {
      return '/';
    }

    const referrerUrl = new URL(document.referrer);

    if (!!referrerUrl && !!apiUrl(referrerUrl.hostname) && /suche/.test(referrerUrl.pathname)) {
      const referrerUrlWithoutHost = referrerUrl.pathname + referrerUrl.search;

      return referrerUrlWithoutHost;
    }

    if (location.href.indexOf('/') !== -1) {
      const splitCurrentLocation = location.href.split('/');

      // remove last segment from url
      splitCurrentLocation.pop();

      // and join the remaining parts to get the url from parent article
      return splitCurrentLocation.join('/');
    }

    return '/';
  }

  const href = backLink();

  if (type === 'link') {
    return (
      <div className="back-element">
        <small>
          <small><i className="fa fa-angle-left color-primary"></i></small>&nbsp;
          <a href={href} title={t('backDowncased')}>{t('backDowncased')}</a>
        </small>
      </div>
    );
  } else if (type === 'button') {
    return (
      <div>
        <a href={href} title={t('backDowncased')} className="button">{t('back')}</a>
      </div>
    );
  }
}

BackElement.propTypes = {
  t: React.PropTypes.func,
  type: React.PropTypes.string
};

export default translate()(BackElement);



// WEBPACK FOOTER //
// ./components/backElement.js